import {IAppState} from '../../state/AppState';

export const getConfig = (state: IAppState) => state.config;
